import React from 'react';
import { BoldSubtitle, Info } from 'components/Text';
import useStyles from './VehicleInfoStyles';
export default function VehicleColumn({
  title,
  value
}) {
  const {
    column
  } = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: column
  }, /*#__PURE__*/React.createElement(BoldSubtitle, null, title), /*#__PURE__*/React.createElement(Info, null, value));
}